import styled from '@emotion/styled';

const Wrapper = styled.div`
  height: 120px;
`;

export {
  Wrapper
};
